import Ad from '../../../api/Ad';
import * as types from './mutation-types';

export const store = async ({commit}, {params}) => {
    await new Ad().store(params);
};

export const show = async ({commit}, {id}) => {
    const json = await new Ad().show(id);

    commit(types.AD, json);
};

export const update = async (context, {id, params}) => {
    await new Ad().update(id, params)
};

export const updateField = async (context, {id, params}) => {
    await new Ad().updateField(id, params);
};

export const destroy = async (context, {id}) => {
    await new Ad().destroy(id)
};

export const getAll = async ({ commit }) => {
    await new Ad().getAll();
};

export default {
    store,
    show,
    update,
    updateField,
    destroy,
    getAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/ad/actions.js